<!-- The pool/spa list and the add/edit form live on the Assets tab, which hosts this component and
     hands it the structure to dose against. -->
<div class="orenda-calculator" *ngIf="structure">
    <slick-container>
        <slick-container-body>
            <div class="card shadow-sm">
                <div class="card-body">
                    <h5 class="card-title border-bottom pb-2">
                        <img src="../../content/images/Orenda_logo.png" />Please Enter Current and Desired Levels: {{ structure?.description }}
                    </h5>
                    <form #chemicalForm="ngForm">
                        <table class="table table-sm align-middle table-bordered table-striped">
                            <thead class="table-light">
                                <tr style="text-align: center;">
                                    <th>Current</th>
                                    <th>Field</th>
                                    <th>Desired</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let field of chemicalFieldsLSI">
                                    <td>
                                        <app-number-picker [min]="chemicalFieldsConfig[field.current]?.min"
                                                           [max]="chemicalFieldsConfig[field.current]?.max"
                                                           [step]="getStep(field.current)"
                                                           [value]="lsi[field.current]"
                                                           (valueChange)="lsi[field.current] = $event; recalcLSI()"></app-number-picker>
                                    </td>
                                    <td style="text-align: center">{{ field.label }}</td>
                                    <td>
                                        <app-number-picker [min]="chemicalFieldsConfig[field.desired]?.min"
                                                           [max]="chemicalFieldsConfig[field.desired]?.max"
                                                           [step]="getStep(field.desired)"
                                                           [value]="lsi[field.desired]"
                                                           (valueChange)="lsi[field.desired] = $event; recalcLSI()"></app-number-picker>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="lsi-cell">
                                        <span [ngClass]="getLsiClass(lsiValue)" class="lsi-pill">
                                            {{ lsiValue | number: '1.2-2' }}
                                        </span>
                                    </td>
                                    <td style="text-align: center; padding-top: 15px">LSI</td>
                                    <td class="lsi-cell">
                                        <span [ngClass]="getLsiClass(lsiDesired)" class="lsi-pill">
                                            {{ lsiDesired | number: '1.2-2' }}
                                        </span>
                                    </td>
                                </tr>
                                <tr *ngFor="let field of chemicalFieldsExtras">
                                    <td>
                                        <app-number-picker [min]="chemicalFieldsConfig[field.current]?.min"
                                                           [max]="chemicalFieldsConfig[field.current]?.max"
                                                           [step]="getStep(field.current)"
                                                           [value]="lsi[field.current]"
                                                           (valueChange)="lsi[field.current] = $event"></app-number-picker>

                                    </td>
                                    <td style="text-align: center; padding-top: 15px">{{ field.label }}</td>
                                    <td>
                                        <app-number-picker [min]="chemicalFieldsConfig[field.desired]?.min"
                                                           [max]="chemicalFieldsConfig[field.desired]?.max"
                                                           [step]="getStep(field.desired)"
                                                           [value]="lsi[field.desired]"
                                                           (valueChange)="lsi[field.desired] = $event"></app-number-picker>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </form>

                    <div class="text-center mt-3" *ngIf="hasChemicalHistory">
                        <button class="btn btn-outline-primary text-nowrap w-100"
                                (click)="saveDesiredSettings()">
                            <i class="bi bi-save"></i> Save Desired Settings
                        </button>
                    </div>

                    <!-- Calculate Button -->
                    <div class="text-center mt-4" *ngIf="areAllInputsFilled()">
                        <button class="save-button btn btn-outline-success text-nowrap w-100" (click)="calculateLSI()">
                            <i class="bi bi-check-circle"></i> Get Recommended Dosages
                        </button>
                    </div>

                    <!-- LSI Results -->
                    <div *ngIf="result" class="mt-4">
                        <div class="card text-center bg-light border-0 shadow-sm p-4">
                            <div *ngIf="result" class="text-start mt-4">
                                <h4 class="fw-bold">LSI Results</h4>
                                <ul class="ps-3">
                                    <li>Current LSI: {{ result.lsiCurrent }}</li>
                                    <li>Desired LSI: {{ result.lsiDesired }}</li>
                                </ul>
                            </div>

                            <div style="text-align: left;">
                                <div *ngIf="dosageResponse?.actions" class="text-start mt-4">
                                    <h4 class="fw-bold">Dosing Actions</h4>

                                    <div *ngFor="let actionKey of dosageKeys()" class="mb-3">
                                        <h6 class="fw-semibold text-capitalize">{{ actionKey }}</h6>
                                        <ul class="ps-3">
                                            <li *ngFor="let action of dosageResponse.actions[actionKey]">
                                                {{ action.name }}
                                                <span *ngIf="action.value">
                                                    &ndash; {{ action.value.quantity | number:'1.2-2' }} {{ action.value.measurement }}
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div *ngIf="dosageResponse?.maintenance" class="text-start mt-4">
                                    <h4 class="fw-bold">Maintenance</h4>
                                    <div *ngFor="let productName of maintenanceKeys()" class="mb-3">
                                        <h6 class="fw-semibold">{{ getDisplayName(productName) }}</h6>
                                        <ul class="ps-3">
                                            <li *ngIf="dosageResponse.maintenance[productName]?.purge">
                                                Purge: {{ dosageResponse.maintenance[productName].purge.quantity }}
                                                {{ dosageResponse.maintenance[productName].purge.measurement }}
                                            </li>
                                            <li *ngIf="dosageResponse.maintenance[productName]?.weekly">
                                                Weekly: {{ dosageResponse.maintenance[productName].weekly.quantity }}
                                                {{ dosageResponse.maintenance[productName].weekly.measurement }}
                                            </li>
                                            <li *ngIf="dosageResponse.maintenance[productName]?.residentialWeekly">
                                                Residential Weekly:
                                                {{ dosageResponse.maintenance[productName].residentialWeekly.quantity }}
                                                {{ dosageResponse.maintenance[productName].residentialWeekly.measurement }}
                                            </li>
                                            <li *ngIf="dosageResponse.maintenance[productName]?.commercialWeekly">
                                                Commercial Weekly:
                                                {{ dosageResponse.maintenance[productName].commercialWeekly.quantity }}
                                                {{ dosageResponse.maintenance[productName].commercialWeekly.measurement }}
                                            </li>
                                            <li *ngIf="dosageResponse.maintenance[productName]?.useAsNeeded">
                                                Use as Needed:
                                                {{ dosageResponse.maintenance[productName].useAsNeeded.quantity | number:'1.2-2' }}
                                                {{ dosageResponse.maintenance[productName].useAsNeeded.measurement }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center mt-4">
                                <button class="btn btn-success px-8" (click)="addOrendaChemicalHistory()">Complete Actions &amp; Maintenance</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </slick-container-body>
    </slick-container>

    <!-- Chemical History -->
    <orenda-chemical-history [jobId]="jobId"
                             [customerId]="customerId"
                             [structureId]="structureId"
                             (historyLoaded)="populateDesiredFields()">
    </orenda-chemical-history>
</div>
